import { motion } from "framer-motion";

interface XPBadgeProps {
  xp: number;
  change?: number;
  size?: "sm" | "md" | "lg";
}

export const XPBadge = ({ xp, change, size = "md" }: XPBadgeProps) => {
  const sizeClasses = {
    sm: "text-sm px-2 py-1",
    md: "text-base px-3 py-1.5",
    lg: "text-lg px-4 py-2"
  };

  return (
    <div className="flex items-center gap-2">
      <motion.div
        initial={{ scale: 1 }}
        animate={change ? { scale: [1, 1.2, 1] } : {}}
        transition={{ duration: 0.3 }}
        className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-primary to-success text-white font-bold shadow-lg ${sizeClasses[size]}`}
      >
        <span>{xp} XP</span>
      </motion.div>
      
      {change && change !== 0 && (
        <motion.span
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          className={`text-sm font-semibold ${change > 0 ? "text-success" : "text-destructive"}`}
        >
          {change > 0 ? "+" : ""}{change}
        </motion.span>
      )}
    </div>
  );
};